import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {TranslateModule} from '@ngx-translate/core';

import {PASSWORD_STRENGTH} from '../../../shared/models/password';

@Component({
  selector: 'q9ma-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, MatProgressBarModule]
})
export class PasswordStrengthComponent {
  @Input() strength: number;

  low = PASSWORD_STRENGTH.LOW;
  medium = PASSWORD_STRENGTH.MEDIUM;
  high = PASSWORD_STRENGTH.HIGH;
  error = PASSWORD_STRENGTH.ERROR;
}
